import React from "react";
import { Helmet } from "react-helmet-async";

const Page404 = () => {
  return (
    <div style={{ backgroundColor: "#fff" }}>
      <Helmet>
        <title>404 - LightningProxies</title>
      </Helmet>

      {/* tos section start */}
      <section className="tos-section">
        <div className="container">
          {/* common heading start */}
          <div className="row">
            <div className="col-lg-12">
              <div className="common-heading">
                <img src="/assets/images/404.svg" alt={404} className="img-fluid" />
                <h6 className="blue-txt-error-page">404</h6>
                <h3 className="h3-error-page">Oops! Looks like something broke </h3>
                <p>Best Advice : Go back to home page</p>
                <a href="/login" className="error-bttn">
                  <img src="/assets/images/left-arrow.svg" alt="<-" className="img-fluid" /> Go Back to Homepage
                </a>
              </div>
            </div>
          </div>
          {/* common heading end */}
        </div>
      </section>
      {/* tos section end */}
    </div>
  );
};

export default Page404;
